<template>
  <div>
    <div v-if="$parent.$parent.$parent.isDataLoading" class="api-loading-indicator">
      <i class="fas fa-sync-alt fa-spin" />
      <span class="ml-2">{{ $parent.$parent.$parent.dataLoadingMessage }}</span>
    </div>
  
    <!--    TODO-->
    <!-- <div v-if="isCalculatingIntersections" class="api-loading-indicator">
          <i class="fas fa-sync-alt fa-spin"></i>
          <span class="ml-2">Calculating intersections...</span>
        </div> -->
  
    <b-modal v-model="is_route_error" title="Route calculating error" ok-only>
      <div v-html="route_error_text" />
    </b-modal>
  
    <b-modal v-model="is_show_map_info" title="Map info" scrollable modal-class="myclass" draggable="false" ok-only>
      <div v-html="map_info_text" />
    </b-modal>
  
    <b-modal visible v-model="is_show_bypass_dialog" header-class="justify-content-center" title="Select bypass method"
      hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
      <div class="col-12 text-center">
        <b-button size="sm" variant="primary" @click="okBypass('detailed')">
          {{ $t('routes.detailed') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="okBypass('general')" class="ml-1">
          {{ $t('routes.general') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="okBypass('filtered')" class="ml-1">
          {{ $t('routes.filtered') }}
        </b-button>
        <b-button size="sm" variant="primary" @click="okBypass('connect')" class="ml-1">
          {{ $t('routes.connect') }}
        </b-button>
        <b-button size="sm" variant="danger" @click="cancelBypass" class="ml-1">
          {{ $t('routes.cancel') }}
        </b-button>
      </div>
    </b-modal>
  
    <!--    <h6 align="center" class="mt-2">ROUTES</h6>-->
  
    <div id="mymap" ref="mm" :style="{ height: height + 'px'}" />
    <!--    <b-overlay :show="$store.state.routes.progress.isCalculating" rounded="sm">-->
    <!--      <div id="mymap" ref="mm" :style="{ height: height + 'px'}"></div>-->
  
    <!--      <template #overlay>-->
    <!--        <div class="text-center">-->
    <!--          <p id="cancel-label">Route/Safety calculating, please wait...</p>-->
  
    <!--          <b-progress class="mt-2" :max=100 show-value show-progress animated>-->
    <!--            <b-progress-bar :value="$store.state.routes.progress.calculatingProgress"-->
    <!--                            :label="`${($store.state.routes.progress.calculatingProgress)}%`"-->
    <!--                            variant="primary"></b-progress-bar>-->
    <!--          </b-progress>-->
  
    <!--          <b-button class="mt-2" size="sm" @click="cancelRoute()" variant="danger">Cancel</b-button>-->
    <!--        </div>-->
    <!--      </template>-->
    <!--    </b-overlay>-->
  </div>
</template>

<script>
import { eventBus, routes_map } from "@/main";
import { mapStores } from 'pinia';
import { useMomentaryStore } from '@/stores/momentary';

export default {
  props: ["map", "height"],

  computed: {
    ...mapStores(useMomentaryStore)
  },
  data() {
    return {
      is_route_error: false,
      is_show_map_info: false,
      is_show_bypass_dialog: false,
      route_error_text: '',
      map_info_text: '',
      isCalculatingIntersections: false
    }
  },
  async mounted() {
    await this.map.init(this.$refs.mm);

    // При инициализации проверяем, есть ли сохраненное состояние карты
    this.restoreMapStateIfNeeded();

    // Убеждаемся, что overlay слои отключены при инициализации routes карты
    this.clearOverlaysOnInit(); eventBus.$off('show-route-error');
    eventBus.$on('show-route-error', (text) => {
      this.route_error_text = text
      this.is_route_error = true
    })

    eventBus.$off('showCalculateByPassDialog');
    eventBus.$on('showCalculateByPassDialog', () => {
      this.is_show_bypass_dialog = true
    })

    // Слушаем события начала и конца пересчета пересечений
    eventBus.$off('intersection-calculation-start');
    eventBus.$on('intersection-calculation-start', () => {
      this.isCalculatingIntersections = true
    })

    eventBus.$off('intersection-calculation-end');
    eventBus.$on('intersection-calculation-end', () => {
      this.isCalculatingIntersections = false
    })

  },
  beforeDestroy() {
    eventBus.$emit('cancel-auto-route')

    // Очищаем все overlay слои при уходе с routes
    if (this.map) {
      // Отключаем все overlay слои, если они есть
      if (this.map.aioLayer && this.map.aioLayer.overlays && this.map.aioLayer.overlays.AIO) {
        if (this.map.map.hasLayer(this.map.aioLayer.overlays.AIO)) {
          this.map.map.removeLayer(this.map.aioLayer.overlays.AIO);
        }
      }

      if (this.map.navareaLayer && this.map.navareaLayer.overlays && this.map.navareaLayer.overlays.navarea) {
        if (this.map.map.hasLayer(this.map.navareaLayer.overlays.navarea)) {
          this.map.map.removeLayer(this.map.navareaLayer.overlays.navarea);
        }
      }

      // Сброс флагов видимости overlay-ев
      if (this.map.isAIOVisible !== undefined) {
        this.map.isAIOVisible = false;
      }
      if (this.map.isNavareaVisible !== undefined) {
        this.map.isNavareaVisible = false;
      }

      // Используем метод destroy для полной очистки
      try {
        this.map.destroy();
        console.log('RoutesMap: карта и ресурсы очищены');
      } catch (error) {
        console.warn('RoutesMap: ошибка при очистке карты', error);
      }
    }

    // Отписываемся от событий
    eventBus.$off('intersection-calculation-start');
    eventBus.$off('intersection-calculation-end');
  },
  methods: {
    // Очистка overlay слоев при инициализации карты в routes
    clearOverlaysOnInit() {
      if (!this.map) return;

      // Принудительно отключаем overlay-и через events
      eventBus.$emit('toggle-aio-layer', false);
      eventBus.$emit('aio-loading-end');
      eventBus.$emit('toggle-navarea-layer', false);
      eventBus.$emit('navarea-loading-end');

      // Задержка, чтобы убедиться что карта полностью инициализирована
      this.$nextTick(() => {
        // Очищаем AIO слой, если он был создан
        if (this.map.aioLayer && this.map.aioLayer.overlays && this.map.aioLayer.overlays.AIO) {
          if (this.map.map && this.map.map.hasLayer(this.map.aioLayer.overlays.AIO)) {
            this.map.map.removeLayer(this.map.aioLayer.overlays.AIO);
          }
        }

        // Очищаем Navarea слой, если он был создан
        if (this.map.navareaLayer && this.map.navareaLayer.overlays && this.map.navareaLayer.overlays.navarea) {
          if (this.map.map && this.map.map.hasLayer(this.map.navareaLayer.overlays.navarea)) {
            this.map.map.removeLayer(this.map.navareaLayer.overlays.navarea);
          }
        }

        // Убеждаемся что флаги видимости сброшены
        if (this.map.isAIOVisible !== undefined) {
          this.map.isAIOVisible = false;
        }
        if (this.map.isNavareaVisible !== undefined) {
          this.map.isNavareaVisible = false;
        }

        console.log('Routes map initialized: overlays cleared');
      });
    },

    // Восстановление состояния карты при переключении между вкладками
    restoreMapStateIfNeeded() {
      if (!this.map || !this.map.map) return;

      const savedState = this.momentaryStore.getMapState();
      this.map.map.setView([savedState.lat, savedState.lon], savedState.zoom);
    },

    cancelBypass() {
      this.is_show_bypass_dialog = false
      routes_map.clearBypass()
    },

    okBypass(type) {
      this.is_show_bypass_dialog = false
      routes_map.startBypassCalculation(type)
    }

    // cancelRoute() {
    //   eventBus.$emit('cancel-auto-route')
    // }
  }
}
</script>

<style scoped>
#mymap {
  z-index: 1;
}

::v-deep .my-class {
  background: black;
  color: white;
}

::v-deep .myclass>div {
  position: absolute !important;
  top: -10px !important;
  left: 10px !important;
  background-color: #77ccdd !important;
}

::v-deep .myclass>.modal-dialog>.modal-content {
  background-color: #77ccdd !important;
}

.api-loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(60, 60, 60, 0.7);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  z-index: 1050;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.api-loading-indicator i {
  margin-right: 6px;
}

.leaflet-grab {
  cursor: auto;
}

.leaflet-dragging .leaflet-grab {
  cursor: move;
}
</style>
